import React, { Component } from "react";

import {
  StyleSheet,
  TouchableOpacity,
  Content,
  View,
  Image,
  Navigator,
  ScrollView,
  Text
} from "react-1app";

import Home from "./Home.js";
import Criarlogin from "./Criarlogin.js";
import Receitas from "./Receitas.js";
import Manual from "./Manual.js";
import Garantia from "./Garantia.js";
import * as actions from "../redux/actions.js";

export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  openPageReceitas() {
    actions.changePage("Receitas");
  }

  openPageManual() {
    actions.changePage("Manual");
  }

  openPageGarantia() {
    actions.changePage("Garantia");
  }

  openPageNovidades() {
    actions.changePage("Novidades");
  }

  openPageGerenciador() {
    actions.changePage("Gerenciador");
  }

  openPageHome() {
    actions.changePage("Home");
  }

  sair() {
    window.location.href = "/";

    this.state.dispatch({
      type: "user_local",
      user_local: null
    });
  }

  render() {
    return (
      <Content style={styles.content}>
        <Image
          style={styles.image1}
          source={"/img/background-site.jpg"}
          resizeMode={"cover"}
        >
          <View style={styles.view21}>
            <ScrollView style={styles.scroll11}>
              <View style={styles.terceira111}>
                <View style={styles.quarta111}>
                  <TouchableOpacity
                    style={styles.button81}
                    onPress={() => {
                      this.openPageHome();
                    }}
                  >
                    <Image
                      style={styles.image11111}
                      source={"/img/logokafer2.png"}
                      resizeMode={"contain"}
                    />
                  </TouchableOpacity>
                </View>
                <TouchableOpacity
                  style={styles.button61111}
                  onPress={() => {
                    this.openPageGerenciador();
                  }}
                >
                  <Text style={styles.text41111} text={"Gerenciar Usuários"} />
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.button2111}
                  onPress={() => {
                    this.openPageNovidades();
                  }}
                >
                  <Text style={styles.text711} text={"Novidades Kafer"} />
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.button4111}
                  onPress={() => {
                    this.openPageReceitas();
                  }}
                >
                  <Text style={styles.text2111} text={"Receitas"} />
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.button5111}
                  onPress={() => {
                    this.openPageManual();
                  }}
                >
                  <Text style={styles.text3111} text={"Manual de Uso"} />
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.button6111}
                  onPress={() => {
                    this.openPageGarantia();
                  }}
                >
                  <Text style={styles.text4111} text={"Termo de garantia"} />
                </TouchableOpacity>
                <View style={styles.decima111} />
              </View>
            </ScrollView>
          </View>
          <TouchableOpacity
            style={styles.adajuda11}
            onPress={() => {
              this.sair();
            }}
          >
            <Text style={styles.text6} text={"Logout"} />
          </TouchableOpacity>
        </Image>
      </Content>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    flex: 1,
    maxWidth: 250
  },
  image1: {
    width: 250,
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    minHeight: 636
  },
  view21: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    backgroundColor: "rgba(255,255,255,0)"
  },
  scroll11: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column"
  },
  terceira111: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: "rgba(255,255,255,0)",
    borderColor: "rgba(255,255,255,0)",
    marginLeft: 5,
    marginRight: 5
  },
  quarta111: {
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    padding: 15,
    borderColor: "rgba(255,255,255,0)"
  },
  button81: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "column"
  },
  image11111: {
    width: 80,
    height: 52,
    alignSelf: "auto",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  button61111: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: 17,
    backgroundColor: "rgba(251,174,23,1)",
    marginTop: 1
  },
  text41111: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    fontWeight: "normal"
  },
  button2111: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: 17,
    borderColor: "rgba(255,255,255,0)",
    backgroundColor: "rgba(251,174,23,1)",
    marginTop: 1
  },
  text711: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    fontWeight: "normal"
  },
  button4111: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: 17,
    backgroundColor: "rgba(251,174,23,1)",
    marginTop: 1
  },
  text2111: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    fontWeight: "normal"
  },
  button5111: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: 17,
    backgroundColor: "rgba(251,174,23,1)",
    marginTop: 1
  },
  text3111: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    fontWeight: "normal"
  },
  button6111: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: 17,
    backgroundColor: "rgba(251,174,23,1)",
    marginTop: 1
  },
  text4111: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    fontWeight: "normal"
  },
  decima111: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    height: 1,
    backgroundColor: "rgba(255,255,255,1)"
  },
  adajuda11: {
    alignSelf: "auto",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "column",
    flexWrap: "nowrap",
    width: 60,
    backgroundColor: "rgba(255,255,255,0)",
    position: "fixed",
    bottom: 20,
    left: 20
  },
  text6: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "center",
    fontWeight: "normal"
  }
});



// WEBPACK FOOTER //
// ./src/views/Menu.js